import { render } from "./home-pricing.vue?vue&type=template&id=4b6e2179"
import script from "./home-pricing.vue?vue&type=script&lang=js"
export * from "./home-pricing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__